import { render, staticRenderFns } from "./OntOptical.vue?vue&type=template&id=47af4c06&"
import script from "./OntOptical.vue?vue&type=script&lang=js&"
export * from "./OntOptical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports